import React from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem, Button } from "reactstrap"
//import {ExcelFile, ExcelSheet} from "react-export-excel"
//import ReactExport from 'react-data-export';
import ReactExport from 'react-export-excel';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const ExcelDownload = props => {
  return (
    <span className="d-inline-block">
      <ExcelFile element={
        <Button className="btn btn-info btn-sm">
          <i className="bx bx-export me-1"></i>
          Export
        </Button>}
        filename={props.filename || "Report"}>
          <ExcelSheet dataSet={props.dataSet} name={props.sheetname || "Sheet1"}/>
      </ExcelFile>
    </span>
  )
}

ExcelDownload.propTypes = {
}

export default ExcelDownload
